import $ from 'jquery';

class Hover {
    constructor(el) {
        const $el = $(el);
        this.image = $el.data('image');
        this.$elImage = $('.js-hover-image');
        this.$bgImage = $('.js-bg-image');

        setTimeout(() => {
            const images = new Image();
            images.src = this.image;
        }, 500);

        $el.mouseover((e) => {
            this.$elImage.addClass('show');
            this.$bgImage.css('background-image', 'url(' + this.image + ')');
        }).mouseleave(() => {
            this.$elImage.removeClass('show');
        });

        $el.mousedown(() => {
            this.$elImage.addClass('show');
            this.$bgImage.css('background-image', 'url(' + this.image + ')');
        });
    }
}

module.exports = Hover;


// WEBPACK FOOTER //
// ./web/app/themes/stash/src/js/helpers/hover.js